module.exports = __webpack_public_path__ + "static/media/DC_PLC.1bf3fc9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/revised/DC_PLC.png
// module id = 327
// module chunks = 0 10 11